require('codemirror/mode/css/css.js');

module.exports = {
	options: {
		mode: 'css',
		extraKeys: {'Ctrl-Space': 'autocomplete'},
		lineNumbers: true
	}
};
